export const accountScroll = (id) => {
    console.log(id, 'as in id') 
  if (id) {
    const targetElement = document.getElementById(id);
    if (targetElement) {
      console.log(targetElement);
      targetElement.scrollIntoView({ behavior: 'smooth' });
      return;
    }
  }
  // Fallback: scroll to top
  window.scrollTo({ top: 1, behavior: 'smooth' });
};

  